module.exports = "/templates/taskdashboard.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/taskdashboard.html
// module id = 470
// module chunks = 0